/**
 * Every path in one place, so a rename is one edit rather than a grep.
 *
 * `as const` matters: it makes these string literals rather than `string`, so a
 * typo in a <Link to={...}> is a compile error.
 */
export const ROUTES = {
  home: '/',
  login: '/login',
  dashboard: '/dashboard',
  logs: '/logs',
  crashes: '/crashes',
  issues: '/issues',
  tickets: '/tickets',
  ticket: '/tickets/:ticketId',
  versions: '/versions',
  releases: '/releases',
  release: '/releases/:releaseId',
  deployments: '/deployments',
  settings: '/settings',
} as const;

/** The page for one release. */
export const releasePath = (id: string): string => `/releases/${id}`;

/** The page for one support ticket. */
export const ticketPath = (id: string): string => `/tickets/${id}`;

/** Reachable without a session. Everything else redirects to login. */
export const PUBLIC_ROUTES: string[] = [ROUTES.login];
